import { Directive, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { ImmomioIconName, QueryParams, TicketingVersion } from '../../../models';
import { CustomerService, RouterService } from '../../../services';
import {
  getResidentAppSettings,
  getSelectedContract,
  getTicketSorting,
  LoadActiveDamageTicketsForSelectedContract,
  LoadActiveDamageTicketsForSelectedContractHQ,
  LoadArchiveDamageTicketsForSelectedContract,
  LoadArchiveDamageTicketsForSelectedContractHQ,
} from '../../../+state';
import { combineLatest, filter, map, Observable, take, tap } from 'rxjs';

@Directive()
export abstract class TicketsOverviewDamagePageBaseComponent implements OnInit {
  @Input() queryParams: QueryParams;
  public showBandODamageFlow = false;
  public archiveViewOpened = false;
  public immomioIconName = ImmomioIconName;

  protected routerService = inject(RouterService);
  protected route = inject(ActivatedRoute);
  protected store = inject(Store);
  protected customerService = inject(CustomerService);

  public ticketingVersion$: Observable<TicketingVersion> = this.store
    .select(getResidentAppSettings)
    .pipe(
      map(response => response?.ticketingVersion),
      filter(response => response !== null)
    );

  ngOnInit() {
    this.showBandODamageFlow = this.customerService.showBandODamageFlow();
  }

  protected reloadTickets() {
    // TODO: IMPROVEMENT check pagination before reloading
    return combineLatest([
      this.store.select(getSelectedContract),
      this.store.select(getTicketSorting),
    ]).pipe(
      tap(([, sort]) => {
        this.ticketingVersion$.pipe(take(1)).subscribe(version => {
          if (version === TicketingVersion.HIERARCHICAL) {
            this.store.dispatch(
              LoadActiveDamageTicketsForSelectedContractHQ({ offset: 0, limit: 20, sort })
            );
            if (this.archiveViewOpened)
              this.store.dispatch(
                LoadArchiveDamageTicketsForSelectedContractHQ({
                  offset: 0,
                  limit: 20,
                  sort,
                })
              );
          } else if (version === TicketingVersion.METADATA) {
            this.store.dispatch(
              LoadActiveDamageTicketsForSelectedContract({ offset: 0, limit: 20, sort })
            );
            if (this.archiveViewOpened)
              this.store.dispatch(
                LoadArchiveDamageTicketsForSelectedContract({
                  offset: 0,
                  limit: 20,
                  sort,
                })
              );
          }
        });
      }),
      take(1)
    );
  }
}
